import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListVehiculePage = withAsyncLoading(async () =>
    import('./ListVehiculePage').then((res) => res.ListVehiculePage)
);

export { LoadableListVehiculePage };
